import React, { useContext } from "react";

import { Button } from "antd";
import { useHistory, Link } from "react-router-dom";

import { ModalContext } from "context/ModalContext";
import AddDomain from "components/widgets/modals/AddDomains";
import NoData from "components/no-data/NoData";
import CustomTable from "components/widgets/table";
import routes from "routes";

export default function Domains({ data }) {
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
  const history = useHistory();

  const viewDomain = (id) => {
    history.push(`/dashboard/${id}`);
  };

  const tableData = {
    icon: "",
    title: "",
    table_fields: [
      { name: "Domain Name", align: "c" },
      { name: "Created Date", align: "c" },
      { name: "Status", align: "c" },
      { name: "Action", align: "c" },
    ],
    search_fields: ["question_code", "answer"],
    row_data: [
      { type: "text", field: "domain", class: "center" },
      { type: "date", field: "created_date", class: "center" },
      { type: "status", field: "status", class: "center" },
      {
        type: "action",
        field: "name",
        class: "center",
        icon: "",
        actions: [
          // {type: 'title', title: 'Actions'},
          {
            type: "menu",
            title: "View",
            field: "system_rm_ref",
            method: viewDomain,
          },
        ],
      },
    ],
  };

  return (
    <>
      <div className="pageheader">
        <div className="breadcrumb pd-0 mg-0 pd-b-20">
          <Link className="breadcrumb-item active" to={routes.dashboard}>
            <i className="icon ion-ios-home-outline " /> Home
          </Link>
          <Link className="breadcrumb-item ">Domains</Link>
        </div>
        <h5>My Domains</h5>
      </div>

      <div className="clearfix">
        <Button
          className="btn-primary btn-blue rounded mb-3 float-right text-white "
          onClick={() => setModalShow(true)}
        >
          Add Domains
        </Button>
      </div>

      <CustomTable
        table_fields={tableData.table_fields}
        row_data={tableData.row_data}
        table_data={data}
        title={tableData.title}
      />
      {/* modal */}
      <AddDomain show={modalShow} onHide={modalClose} />
    </>
  );
}
